import logoDark from '@/shared/logos/logo-horizontal-dark.svg';
import logoLight from '@/shared/logos/logo-horizontal-light.svg';
import { cn } from '@/lib/utils';
import { ASPECT_RATIO } from './constants';
import { LogoProps } from './types';
import { useBrandTheme } from '../useTheme';
import { useEffect, useState } from 'react';

const Logo = (props: LogoProps) => {
  const {
    alt = 'WhiteLine',
    className,
    height,
    size
  } = props;

  const [isMounted, setIsMounted] = useState<boolean>(false);

  const {
    isDark
  } = useBrandTheme();

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const h = height ?? size ?? 40;
  const src = !isMounted || isDark ? logoDark : logoLight;
  const w = Math.round(h * ASPECT_RATIO);

  return (
    <img
      className={cn('block select-none', className)}
      alt={alt}
      draggable={false}
      height={h}
      src={src}
      width={w}
    />
  );
};

export default Logo;